import React, { useState } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { Helmet } from 'react-helmet-async';

const ContactContainer = styled.div`
  padding: 120px 50px 80px;
  max-width: 1200px;
  margin: 0 auto;
`;

const ContactHeader = styled.div`
  text-align: center;
  margin-bottom: 60px;
`;

const ContactTitle = styled.h1`
  font-size: 3rem;
  margin-bottom: 20px;
`;

const ContactContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 50px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const ContactForm = styled.form`
  display: flex;
  flex-direction: column;
`;

const FormGroup = styled.div`
  margin-bottom: 20px;
`;

const FormLabel = styled.label`
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
`;

const FormInput = styled.input`
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
`;

const FormTextarea = styled.textarea`
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
  min-height: 150px;
`;

const SubmitButton = styled.button`
  display: inline-block;
  padding: 12px 24px;
  margin-top: 20px;
  background-color: #000;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s;
  
  &:hover {
    background-color: #333;
  }
`;

const ContactInfo = styled.div`
  padding: 30px;
  background-color: #f9f9f9;
  border-radius: 8px;
`;

const ContactInfoTitle = styled.h4`
  font-size: 1.5rem;
  margin-bottom: 20px;
`;

const ContactInfoItem = styled.div`
  margin-bottom: 15px;
`;

const ContactDescription = styled.div`
  margin-top: 30px;
  
  h4 {
    font-size: 1.5rem;
    margin-bottom: 15px;
  }
  
  p {
    line-height: 1.6;
  }
`;

const ContactPage = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    subject: '',
    message: ''
  });
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic
    console.log('Form submitted:', formData);
    // Reset form
    setFormData({
      firstName: '',
      lastName: '',
      email: '',
      subject: '',
      message: ''
    });
    alert('Thank you for your message! We will get back to you soon.');
  };
  
  return (
    <>
      <Helmet>
        <title>Contact Dogukan Yaylaci | IT & Web Development Services</title>
        <meta name="description" content="Get in touch with Dogukan Yaylaci for IT services, web development, frontend design, digital marketing, or collaboration opportunities. Contact for expert IT solutions." />
        <meta name="keywords" content="contact Dogukan Yaylaci, IT services, web development contact, frontend developer hire, IT consultant contact" />
        <link rel="canonical" href="https://dogukanyaylaci.dev/contact" />
      </Helmet>
      
      <ContactContainer>
        <ContactHeader>
          <ContactTitle>Let's build something great</ContactTitle>
        </ContactHeader>
        
        <ContactContent>
          <div>
            <ContactForm onSubmit={handleSubmit}>
              <FormGroup>
                <FormLabel>First Name</FormLabel>
                <FormInput 
                  type="text" 
                  name="firstName" 
                  value={formData.firstName} 
                  onChange={handleChange} 
                  required 
                />
              </FormGroup>
              
              <FormGroup>
                <FormLabel>Last Name</FormLabel>
                <FormInput 
                  type="text" 
                  name="lastName" 
                  value={formData.lastName} 
                  onChange={handleChange} 
                  required 
                />
              </FormGroup>
              
              <FormGroup>
                <FormLabel>Email</FormLabel>
                <FormInput 
                  type="email" 
                  name="email" 
                  value={formData.email} 
                  onChange={handleChange} 
                  required 
                />
              </FormGroup>
              
              <FormGroup>
                <FormLabel>Subject</FormLabel>
                <FormInput 
                  type="text" 
                  name="subject" 
                  value={formData.subject} 
                  onChange={handleChange} 
                  required 
                />
              </FormGroup>
              
              <FormGroup>
                <FormLabel>Your Message</FormLabel>
                <FormTextarea 
                  name="message" 
                  value={formData.message} 
                  onChange={handleChange} 
                  required 
                />
              </FormGroup>
              
              <SubmitButton type="submit">Submit Form</SubmitButton>
            </ContactForm>
          </div>
          
          <div>
            <ContactInfo>
              <ContactInfoTitle>Main</ContactInfoTitle>
              <ContactInfoItem>
                Göreme, Muze Cad. No: 11, 50180 Göreme/Nevşehir, Turkey
              </ContactInfoItem>
              <ContactInfoItem>
                0-000-000-0000
              </ContactInfoItem>
              <ContactInfoItem>
                dgyaylaci@gmail.com
              </ContactInfoItem>
            </ContactInfo>
            
            <ContactDescription>
              <h4>Feel free contact me</h4>
              <p>
                You can receive free consulting services and discuss your project or business. 
                All you need to do is fill out the form. I am currently open to job offers; 
                you can reach me through my LinkedIn profile or my CV.
              </p>
            </ContactDescription>
          </div>
        </ContactContent>
      </ContactContainer>
    </>
  );
};

export default ContactPage; 